import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { SERVICES, API } from "@/data/site";

const inputCls =
  "w-full border border-[#262A35] bg-[#0B0C0E] px-4 py-3 text-sm text-white placeholder:text-gray-600 focus:border-[#3B82F6] focus:outline-none transition-colors";

export default function BookingForm({ initialService = "" }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    vehicle: "",
    service: initialService,
    date: "",
    notes: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.vehicle || !form.service) {
      toast.error("Please fill name, phone, vehicle and service.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/bookings`, form);
      toast.success("Booking request received. We will call you back shortly.");
      setForm({ name: "", phone: "", vehicle: "", service: "", date: "", notes: "" });
    } catch {
      toast.error("Could not submit. Please call us directly at 7010080038.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="booking-form" className="space-y-4">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-gray-500">
            Your Name *
          </label>
          <input
            data-testid="booking-form-name-input"
            className={inputCls}
            placeholder="e.g. Karthik Raja"
            value={form.name}
            onChange={set("name")}
          />
        </div>
        <div>
          <label className="font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-gray-500">
            Phone Number *
          </label>
          <input
            data-testid="booking-form-phone-input"
            className={inputCls}
            placeholder="10-digit mobile"
            value={form.phone}
            onChange={set("phone")}
          />
        </div>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className="font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-gray-500">
            Vehicle & Year *
          </label>
          <input
            data-testid="booking-form-vehicle-input"
            className={inputCls}
            placeholder="e.g. Hyundai Creta 2023"
            value={form.vehicle}
            onChange={set("vehicle")}
          />
        </div>
        <div>
          <label className="font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-gray-500">
            Service *
          </label>
          <select
            data-testid="booking-form-service-select"
            className={inputCls}
            value={form.service}
            onChange={set("service")}
          >
            <option value="">Select a service</option>
            {SERVICES.map((s) => (
              <option key={s.id} value={s.id}>
                {s.title}
              </option>
            ))}
            <option value="general">General Enquiry</option>
          </select>
        </div>
      </div>
      <div>
        <label className="font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-gray-500">
          Preferred Date
        </label>
        <input
          data-testid="booking-form-date-input"
          type="date"
          className={inputCls}
          value={form.date}
          onChange={set("date")}
        />
      </div>
      <div>
        <label className="font-mono2 mb-1.5 block text-[10px] uppercase tracking-[0.25em] text-gray-500">
          Special Notes
        </label>
        <textarea
          data-testid="booking-form-notes-input"
          rows={3}
          className={inputCls}
          placeholder="Anything we should know about your vehicle?"
          value={form.notes}
          onChange={set("notes")}
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid="booking-form-submit-button"
        className="font-mono2 w-full bg-[#3B82F6] px-6 py-4 text-sm font-bold uppercase tracking-[0.25em] text-white transition-colors hover:bg-[#2563EB] disabled:opacity-60"
      >
        {loading ? "Sending..." : "Request Booking"}
      </button>
    </form>
  );
}
